<div #menuClosed class="closed-container" *ngIf="!isOpen" (click)="open()">
  <div class="burger-menu">
    <img src="assets/burger-menu-black.svg" />
  </div>
  <div class="project-name">
    <span class="project-code">{{ projectCode }}</span>
    &nbsp;<span class="client-name-bold">{{ clientName }}</span> &nbsp;{{
      projectName
    }}
  </div>
</div>

<div #menuOpen class="open-container" *ngIf="isOpen">
  <div class="version-section">
    <div class="header-row" (click)="close()">
      <div class="burger-menu">
        <img src="assets/burger-menu-purple.svg" />
      </div>
      <div class="label">
        <span class="project-code">{{ projectCode }}</span>
        &nbsp;<span class="client-name-bold">{{ clientName }}</span> &nbsp;{{
          projectName
        }}
      </div>
    </div>
    <hr />
    <div class="list-row" *ngIf="!createView">
      <div class="title">
        {{ 'VERSION_MENU.ESTIMATE_VERSIONS' | translate }}
      </div>
      <div class="list version-list">
        <div
          class="version"
          *ngFor="let version of versionList; index as index"
          (click)="onSelectVersion(version)"
        >
          <div
            class="enumeration"
            [class.selected]="isSelectedVersion(version)"
          >
            {{ getVersionLabel(index) }}
          </div>
          <div
            class="name"
            [id]="versionId(version)"
            [class.selected]="isSelectedVersion(version)"
          >
            <img
              class="checkmark"
              src="assets/checkmark-double-blue-bold.svg"
              *ngIf="version.isApproved"
            />
            <img
              class="checkmark"
              src="assets/checkmark-double-purple.svg"
              *ngIf="version.isAddedToApproved"
            />
            <div
              *ngIf="version._id !== renameId"
              (click)="onSelectVersion(version)"
              class="version-name"
            >
              {{ version.name }}
            </div>
            <input
              id="{{ 'input' + version._id }}"
              *ngIf="version._id === renameId"
              [value]="renameInput"
              (focusout)="cancelRename()"
              (keyup)="onRenameKeyUp($event)"
              focusSelect
            />
            <div
              #versionActionMenu
              class="kebab-menu version-kebab-menu"
              [opsActionMenu]="'version-action-menu-' + version._id"
              [optionsFactory]="getOptions.bind(this, version)"
              [position]="'auto'"
              [allowFlip]="true"
              [offset]="{ x: -10, y: 5 }"
              (click)="$event.stopPropagation()"
            >
              <img src="assets/kebab-menu-purple.svg" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action menus container - outside scrollable list to avoid clipping -->
    <div class="action-menus-container" *ngIf="!createView">
      <ops-action-menu
        *ngFor="let version of versionList"
        [menuId]="'version-action-menu-' + version._id"
        (itemSelected)="onSelectAction($event, version?._id!, version?.name!)"
      ></ops-action-menu>
    </div>

    <div class="create-row" *ngIf="createView">
      <div class="title">{{ 'VERSION_MENU.VERSION_NAME' | translate }}</div>
      <div class="name-row">
        <div class="enumeration">{{ newVersionLabel }}</div>
        <input
          class="name-input"
          type="text"
          [value]="newVersionName"
          (keyup)="onInputName($event)"
          focusSelect
        />
      </div>
      <div class="selection-row">
        <div
          class="cloning-item"
          *ngFor="let element of selectionElements"
          (click)="onToggleElement(element)"
        >
          <div class="checkbox">
            <img
              src="assets/checkbox-checked-square-blue-opaque.svg"
              *ngIf="element.isSelected"
            />
          </div>
          <div class="label">{{ element.title }}</div>
        </div>
      </div>
    </div>

    <div class="button-row">
      <div class="create-btn" *ngIf="!createView" (click)="onCreateNew()">
        {{ 'VERSION_MENU.CREATE_NEW' | translate }}
      </div>
      <div class="cancel-btn" *ngIf="createView" (click)="onCancel()">
        {{ 'VERSION_MENU.CANCEL' | translate }}
      </div>
      <div class="save-btn" *ngIf="createView" (click)="onSave()">
        {{ 'VERSION_MENU.SAVE' | translate }}
      </div>
    </div>

    <div class="cost-row" *ngIf="!createView">
      <hr />
      <div class="cost-button clickable" (click)="onSelectCost()">
        <div class="label">
          {{ 'VERSION_MENU.PRODUCTION_COST' | translate }}
        </div>
        <div class="arrow">
          <img src="assets/arrow-right-purple.svg" />
        </div>
      </div>
    </div>
  </div>

  <div class="projects-section">
    <div class="title">{{ 'VERSION_MENU.PROJECTS' | translate }}</div>
    <div id="search-bar" class="search-bar">
      <img src="assets/search-purple.svg" alt="Search position" />
      <input
        autofocus
        (input)="onTypeSearch($event)"
        [placeholder]="'VERSION_MENU.SEARCH_PROJECTS' | translate"
      />
    </div>
    <div class="project-list">
      <!-- prettier-ignore -->
      <div class="project" *ngFor="let project of displayedProjects | orderBy : 'code':false:'case-insensitive'"
        (click)="onSelectProject(project._id)"
      >
        <div class="project-code">{{ project.code }}</div>
        &nbsp;
        <span class="client-name">{{ project.client?.name! }}</span> &nbsp;
        <span class="project-name">{{ project.name }}</span>
      </div>
    </div>
  </div>
</div>

<div #background class="background" *ngIf="isOpen" (click)="close()"></div>
